import axios from "axios";

export default {
    getMetricsMonitoringByCompanyId(_, params) {
        return axios.post('/api/input/getmetricsmonitoringbycompanyid', params, { withCredentials: true });
    },

    getTotalMetricsMonitoringByCompanyId(_, params) {
        return axios.post('/api/input/gettotalmetricsmonitoringbycompanyid', params, { withCredentials: true });
    },

    createMetricsInput(_, params) {
        return axios.post('/api/input/createmetricsinput', params, { withCredentials: true });
    },

    createRequestedMetricsInput(_, params) {
        return axios.post('/api/input/create-requested-metrics-input', params, { withCredentials: true });
    },

    updateRequestedMetricsInput(_, params) {
        return axios.post(`/api/input/update-requested-metrics-input/${params.metrics_input_table_id}`, params.body, { withCredentials: true });
    },

    getRequestedMetricsPrimaryCompanies() {
        return axios.get('/api/input/requested-metrics/primary-companies', { withCredentials: true });
    },

    // Pass { primary_company_id } to scope to a single primary, or {} for the union across all primaries.
    // Optional { facility_id } scopes the attached `company_inputs` to that facility (defaults to 0).
    getRequestedMetricsTree(_, params) {
        const id = params && params.primary_company_id;
        const path = id ? `/api/input/requested-metrics/tree/${id}` : `/api/input/requested-metrics/tree`;
        const config = { withCredentials: true };
        if (params && params.facility_id !== undefined && params.facility_id !== null) {
            config.params = { facility_id: params.facility_id };
        }
        return axios.get(path, config);
    },

    updateMetrics(_, params) {
        let body = {
            company_id: params.company_id,
            year: params.year,
            quarter: params.quarter,
            facility_id: params.facility_id,
            updated_by: params.updated_by,
            value: params.value
        }

        if (params.metric_kpi_id) {
            body["metric_kpi_id"] = params.metric_kpi_id;
        } else if (params.sub_metric_kpi_id) {
            body["sub_metric_kpi_id"] = params.sub_metric_kpi_id;
        }

        return axios.post(`/api/input/updatemetricsinput/${params.metrics_input_table_id}`, body, {withCredentials: true});
    },

    deleteMetricInput(_, params) {
        return axios.post("/api/input/deletemetricsinput", params, {withCredentials: true});
    },
    
    getFacilities(_, params){
        return axios.post('/api/facility/getfacilitiesbycompanyid', params, { withCredentials: true });
    },

    // GRI Indexes and Global Goals //

    getGriIndexes(_, params) {
        return axios.post("/api/griindex/getgriindexes", params, {withCredentials: true});
    },

    // urgent fix //

    getCategories() {
        return axios.get(`/api/input/get-sust-categories`, {withCredentials: true});
    },

    getElementsByPriority(_, id) {
        return axios.get(`/api/input/get-elements-by-priority/${id}`, {withCredentials: true});
    },

    getTargetsByElement(_, id) {
        return axios.get(`/api/input/get-targets-by-element/${id}`, {withCredentials: true});
    },
    
    getKpisByTarget(_, id) {
        return axios.get(`/api/input/get-kpis-by-target/${id}`, {withCredentials: true});
    },
    
    getMetricsByKpi(_, id) {
        return axios.get(`/api/input/get-metrics-by-kpi/${id}`, {withCredentials: true});
    },
    
    getSubMetricsByMetric(_, id) {
        return axios.get(`/api/input/get-sub-metrics-by-metric/${id}`, {withCredentials: true});
    },
    
    getInputAnalysis(_, params) {
        return axios.get(`/api/input/get-inputs-analysis/${params.company_id}/${params.facility_id}/${params.is_yearly}/${params.year}`, {withCredentials: true});
    },
    
    exportInputAnalysis(_, params) {
        return axios.get(`/api/input/export-inputs-analysis/${params.company_id}/${params.facility_id}/${params.is_yearly}/${params.year}`, {responseType: 'blob', withCredentials: true});
    },
    
    getInputDetails(_, id) {
        return axios.get(`/api/input/get-input-details/${id}`, {withCredentials: true});
    },
    
    redirectToMetric(_, params) {
        return axios.get(`/api/input/redirect-to-metric/${params.metric_kpi_id}/${params.sub_metric_kpi_id}`, { withCredentials: true });
    },
    
    getAssignments(_, facility_id) {
        return axios.get(`/api/input/assignments/${facility_id}`, {withCredentials: true});
    },

    //#region DISCUSSIONS

    addComment(_, params) {
        return axios.post(`/api/discussion/add-comment/${params.type}`, params.body, {withCredentials: true});
    },

    updateComment(_, params) {
        return axios.post(`/api/discussion/update-comment/${params.id}`, params.body, {withCredentials: true});
    },

    deleteComment(_, params) {
        return axios.delete(`/api/discussion/${params.id}`, {withCredentials: true});
    },

    fetchDiscussion(_, params) {
        return axios.get(`/api/discussion/${params.type}/${params.relevant_id}`, {withCredentials: true});
    },

    async getMetricById(_, id) {
        const response = await axios.get(`/api/input/get-metric-by-id/${id}`, {withCredentials: true});
        if (response.status != 200) return false;
        return response.data;
    },

    //#endregion
}